/**
 * 健康信息
 */
import requestByGateway from '@/request/request.gateway';
import requestByBasic from '@/request/request.basic';
import config from '@/config';

const healthManagement = {
	//------------------疫情日报api---------------------------
	getEpidemicList(params) {
		return requestByBasic.get(config.api.ps + '/School/EpidemicSituation/get', {
			params
		});
	},
	// 下载表格
	tableDownload(params) {
		// 这种表格下载方式，直接用url跳转。需要处理参数
		let paramsArray = [];
		for (let key in params) {
			paramsArray.push(`${key}=${params[key]}`);
		}
		let url = config.api.ps + '/School/EpidemicSituation/exportList';
		let jumpUrl = url + '?' + paramsArray.join('&');
		window.location.href = jumpUrl;
	},
	/**
	 *
	 * 学生体温列表
	 */
	gethealthList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.workneapi}/console/v1/temperature_list`,
			headers: config.headers,
			params
		});
	},
	/**
	 *
	 * 学生测量体温时段列表
	 */
	getperiodList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.workneapi}/console/v1/time_list`,
			headers: config.headers,
			params
		});
	},
	/**
	 *
	 * 学生测量体温时段列表
	 */
	getteacherList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.workneapi}/console/v1/staff_temperature_list`,
			headers: config.headers,
			params
		});
	}
};

export default healthManagement;
